import React, { useEffect, useState, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import { assortmentHierarcyContext } from "../context/AssortmentHierarcyContext";

import Textarea from "@mui/joy/Textarea";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import useLoginfo from "../../utils/useLoginfo";

const EditForm = () => {
  const {
    addUpdateAssortmentHierarcyAction,
    getDepartmentAssortmentHierarcyAction,
    getSingleAssortmentHierarcyAction,
    departments,
    SingleRow,
  } = useContext(assortmentHierarcyContext);

  const history = useHistory()
  //OKTA
  const { tokenVal } = useLoginfo()

  const { editID } = useParams();

  useEffect(() => {

    getDepartmentAssortmentHierarcyAction(tokenVal);
    getSingleAssortmentHierarcyAction(editID, tokenVal);

  }, [tokenVal]);

  const [formData, setFormData] = useState({
    ASSORTMENT_NBR: "",
    ACTIVE: "",
    ADMIN_ONLY: "",
    DEPARTMENT: "",
    AVAILABILITY: "",
    START_DATE: "",
    END_DATE: "",
    MARKDOWN: "",
    DATING: "",
    ASSORTMENT_DESC: "",
    FIXED_TIME: "",
    LEAD_TIME: "",
    MAX_SHIP_DATE: "",
    MIN_SHIP_DATE: "",
    LAST_CHANCE: "N",
    ASSORTMENT_ID: "",
    CREATED_BY: "1",
    KITTED:"P"
  });

  useEffect(() => {
    // console.log(SingleRow);
    let end = new Date(SingleRow?.END_DATE).getMonth() + 1;
    let start = new Date(SingleRow?.START_DATE).getMonth() + 1;
    let maxi = new Date(SingleRow?.MAX_SHIP_DATE).getMonth() + 1;
    let mini = new Date(SingleRow?.MIN_SHIP_DATE).getMonth() + 1;

    setFormData({
      ASSORTMENT_NBR: SingleRow?.ASSORTMENT_NBR,
      ACTIVE: SingleRow?.ACTIVE,
      ADMIN_ONLY: SingleRow?.ADMIN_ONLY,
      DEPARTMENT: SingleRow?.DEPARTMENT,
      AVAILABILITY: SingleRow?.AVAILABILITY,
      START_DATE:
        new Date(SingleRow?.START_DATE).getFullYear() +
        "-" +
        (start < 10 ? "0" + start : start) +
        "-" +
        (new Date(SingleRow?.START_DATE).getDate() < 10
          ? "0" + new Date(SingleRow?.START_DATE).getDate()
          : new Date(SingleRow?.START_DATE).getDate()),
      END_DATE:
        new Date(SingleRow?.END_DATE).getFullYear() +
        "-" +
        (end < 10 ? "0" + end : end) +
        "-" +
        (new Date(SingleRow?.END_DATE).getDate() < 10
          ? "0" + new Date(SingleRow?.END_DATE).getDate()
          : new Date(SingleRow?.END_DATE).getDate()),
      MARKDOWN: SingleRow?.MARKDOWN,
      DATING: SingleRow?.DATING,
      ASSORTMENT_DESC: SingleRow?.ASSORTMENT_DESC,
      FIXED_TIME: SingleRow?.FIXED_TIME,
      LEAD_TIME: SingleRow?.LEAD_TIME,
      MAX_SHIP_DATE:
        new Date(SingleRow?.MAX_SHIP_DATE).getFullYear() +
        "-" +
        (maxi < 10 ? "0" + maxi : maxi) +
        "-" +
        (new Date(SingleRow?.MAX_SHIP_DATE).getDate() < 10
          ? "0" + new Date(SingleRow?.MAX_SHIP_DATE).getDate()
          : new Date(SingleRow?.MAX_SHIP_DATE).getDate()),
      MIN_SHIP_DATE:
        new Date(SingleRow?.MIN_SHIP_DATE).getFullYear() +
        "-" +
        (mini < 10 ? "0" + mini : mini) +
        "-" +
        (new Date(SingleRow?.MIN_SHIP_DATE).getDate() < 10
          ? "0" + new Date(SingleRow?.MIN_SHIP_DATE).getDate()
          : new Date(SingleRow?.MIN_SHIP_DATE).getDate()),
      LAST_CHANCE: SingleRow?.LAST_CHANCE,
      ASSORTMENT_ID: SingleRow?.ASSORTMENT_ID,
      CREATED_BY: "1",
      KITTED:SingleRow?.KITTED
    });
  }, [SingleRow]);

  //handle form change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [flag, setflag] = useState(false);
  //handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();

    //update row
    if (flag) {
      let daydiff =
        (new Date(formData.END_DATE).getTime() -
          new Date(formData.START_DATE).getTime()) /
        (1000 * 60 * 60 * 24);

      let daydiffship =
        (new Date(formData.MAX_SHIP_DATE).getTime() -
          new Date(formData.MIN_SHIP_DATE).getTime()) /
        (1000 * 60 * 60 * 24);

      let daydiffend =
        (new Date(formData.END_DATE).getTime() -
          new Date(formData.MAX_SHIP_DATE).getTime()) /
        (1000 * 60 * 60 * 24);

      let daydiffstart =
        (new Date(formData.MIN_SHIP_DATE).getTime() -
          new Date(formData.START_DATE).getTime()) /
        (1000 * 60 * 60 * 24);

      if (new Date(formData.MIN_SHIP_DATE).getFullYear().toString().length != 4)
        alert("Min Ship Date is invalid");
      else if (new Date(formData.MAX_SHIP_DATE).getFullYear().toString().length != 4)
        alert("Max Ship Date is invalid");
      else if (new Date(formData.START_DATE).getFullYear().toString().length != 4)
        alert("Start Date is invalid");
      else if (new Date(formData.END_DATE).getFullYear().toString().length != 4)
        alert("End Date is invalid");
      else if (daydiffship <= 0) alert("Max Ship Date should be after Min Ship Date");
      else if (daydiff <= 0) alert("End Date should be after Start Date");
      // else if (daydiffend <= 0)
      //   alert("End Date should be after Max Ship Date");
      // else if (daydiffstart <= 0)
      //   alert("Start Date should be before Min Ship Date");
      else {
        addUpdateAssortmentHierarcyAction({ ...formData }, tokenVal, history);
        // history.push("/asssortment");
      }
    }
  };

  //handle form cancel
  const handleCancel = (e) => {
    window.location.href = "/asssortment";
  };

  return (
    <div>
      <Breadcrumbs
        separator="›"
        aria-label="breadcrumb"
        style={{ marginLeft: "15px" }}
      >
        <Link underline="hover" color="inherit" href="/asssortment">
          View Assortment
        </Link>
        <Link
          underline="hover"
          color="text.primary"
          href={`/edit-asssortment-hierarcy/${editID}`}
          aria-current="page"
        >
          Edit Assortment Form
        </Link>
      </Breadcrumbs>

      <h2 style={{ textAlign: "center" }}>Edit Assortment Form</h2>

      <form className="flex-container" onSubmit={handleSubmit}>
        <div style={{ marginLeft: "15px" }}>
          <div className="flex-container">
            <label className="">Admin Only</label>
            <TextField
              size="small"
              required={flag}
              name="ADMIN_ONLY"
              value={formData.ADMIN_ONLY}
              onChange={handleChange}
              className="depart"
              id="outlined-select-admin"
              select
            >
              <MenuItem key="Y" value="Y">
                Y
              </MenuItem>
              <MenuItem key="N" value="N">
                N
              </MenuItem>
            </TextField>
          </div>

          <div className="flex-container">
            <label className="">Min Ship Date</label>
            <TextField
              required={flag}
              name="MIN_SHIP_DATE"
              value={formData.MIN_SHIP_DATE}
              onChange={handleChange}
              id="min-date"
              type="date"
              className="depart"
            />
          </div>

          <div className="flex-container">
            <label className="">Max Ship Date</label>
            <TextField
              size="small"
              required={flag}
              name="MAX_SHIP_DATE"
              value={formData.MAX_SHIP_DATE}
              onChange={handleChange}
              id="max-date"
              type="date"
              className="depart"
            />
          </div>

          <div className="flex-container">
            <label>Assortment Description</label>
            <Textarea
              minRows={2}
              variant="soft"
              required={flag}
              disabled={true}
              name="ASSORTMENT_DESC"
              value={formData.ASSORTMENT_DESC}
              type="text"
              className="depart"
              style={{ border: "1px solid" }}
            />
          </div>

          <div className="flex-container">
            <label className="">Active</label>
            <TextField
              size="small"
              required={flag}
              name="ACTIVE"
              value={formData.ACTIVE}
              onChange={handleChange}
              className="depart"
              id="outlined-select-active"
              select
            >
              <MenuItem key="Y" value="Y">
                Y
              </MenuItem>
              <MenuItem key="N" value="N">
                N
              </MenuItem>
            </TextField>
          </div>

          <div className="flex-container">
            <label className="">Markdown</label>
            <TextField
              size="small"
              style={{ background: "rgb(247, 247, 248)" }}
              required={flag}
              disabled={true}
              name="MARKDOWN"
              value={formData.MARKDOWN}
              type="text"
              id="outlined-mark"
              className="depart"
            />
          </div>

          <div className="flex-container">
            <label className="">Dating</label>
            <TextField
              size="small"
              style={{ background: "rgb(247, 247, 248)" }}
              required={flag}
              disabled={true}
              name="DATING"
              value={formData.DATING}
              type="text"
              id="outlined-dating"
              className="depart"
            />
          </div>

          <div className="flex-container">
            <label className="">Fixed Time</label>
            <TextField
              size="small"
              required={flag}
              name="FIXED_TIME"
              value={formData.FIXED_TIME}
              onChange={handleChange}
              type="text"
              id="outlined-fixed"
              className="depart"
            />
          </div>
        </div>

        <div style={{ marginTop: "-23px", marginLeft: "15px" }}>
          <div className="flex-container">
            <label className="">Assortment Number</label>
            <TextField
              size="small"
              style={{ background: "rgb(247, 247, 248)" }}
              disabled={true}
              required={true}
              className="depart"
              name="ASSORTMENT_NBR"
              value={formData.ASSORTMENT_NBR}
              type="text"
              id="outlined-nbr"
            />
          </div>

          <div className="flex-container">
            <label className="">Department</label>
            <TextField
              size="small"
              required={flag}
              name="DEPARTMENT"
              value={formData.DEPARTMENT}
              onChange={handleChange}
              className="depart"
              id="outlined-select-currency"
              select
            >
              {departments
                .filter((x) => {
                  return x.ACTIVE == "Y";
                })
                .map((option) => (
                  <MenuItem key={option.DEPT_CD} value={option.DEPT_CD}>
                    {option.DEPT_DS}
                  </MenuItem>
                ))}
            </TextField>
          </div>

          <div className="flex-container">
            <label className="">Availabilty</label>
            <TextField
              size="small"
              style={{ background: "rgb(247, 247, 248)" }}
              required={flag}
              disabled={true}
              name="AVAILABILITY"
              value={formData.AVAILABILITY}
              type="text"
              id="outlined-avail"
              className="depart"
            />
          </div>

          <div className="flex-container">
            <label className="">Start Date</label>
            <TextField
              size="small"
              required={flag}
              name="START_DATE"
              value={formData.START_DATE}
              onChange={handleChange}
              id="start-date"
              type="date"
              className="depart"
            />
          </div>

          <div className="flex-container">
            <label className="">End Date</label>
            <TextField
              size="small"
              required={flag}
              name="END_DATE"
              value={formData.END_DATE}
              onChange={handleChange}
              id="end-date"
              type="date"
              className="depart"
            />
          </div>

          <div className="flex-container">
            <label className="">Lead Time</label>
            <TextField
              size="small"
              required={true}
              className="depart"
              name="LEAD_TIME"
              value={formData.LEAD_TIME}
              onChange={handleChange}
              type="text"
              id="outlined-lead"
            />
          </div>

          <div className="flex-container">
            <label className="">Last Chance Indicator</label>
            <TextField
              size="small"
              required={flag}
              name="LAST_CHANCE"
              value={formData.LAST_CHANCE}
              onChange={handleChange}
              className="depart"
              id="outlined-select-last"
              select
            >
              <MenuItem key="Y" value="Y">
                Y
              </MenuItem>
              <MenuItem key="N" value="N">
                N
              </MenuItem>
            </TextField>
          </div>
          <div className="flex-container">
            <label className="">Kitted</label>

            <TextField
              size="small"
              required={flag}
              name="KITTED"
              value={formData.KITTED}
              onChange={handleChange}
              className="depart"
              id="outlined-select-active"
              select
            >
              <MenuItem  selected key="P" value="P">
                P 
              </MenuItem>
              <MenuItem key="L" value="L">
                L
              </MenuItem>
            </TextField>
          </div>

          <div className="" style={{ marginTop: "65px", display: "flex" }}>
            <div className="save-btn">
              <Button
                type="submit"
                variant="contained"
                color="success"
                onClick={(e) => setflag(true)}
                size="large"
              >
                <span className="cat-radio">Save</span>
              </Button>
            </div>
            <div>
              <Button
                className="cancel-btn"
                variant="contained"
                color="error"
                onClick={handleCancel}
                size="large"
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
        <div className="search-btn">
          {/* <Button
            variant="contained"
            onClick={() => handleSearch(formData.ASSORTMENT_NBR)}
            color="secondary"
            size="large"
          >
            Search
          </Button> */}
        </div>
      </form>
    </div>
  );
};

export default EditForm;
